module.exports = __webpack_public_path__ + "img/beach-1853939_1920.d6885e9f.jpg";